// Salon booking policies (surfaced to customers at booking and in the
// reschedule/cancel flow). `category` drives presets + reschedule/cancel
// targeting; `title` is an editable display name (preset to the category
// label); `body` is rich text stored as sanitized HTML.

export type PolicyCategory =
  | "cancellation"
  | "late"
  | "no_show"
  | "rescheduling"
  | "other";

export interface Policy {
  id: string;
  category: PolicyCategory;
  title: string;
  body: string;
}

export interface CreatePolicyRequest {
  salon_id: string;
  category: PolicyCategory;
  title: string;
  body: string;
}

export interface UpdatePolicyRequest {
  id: string;
  category?: PolicyCategory;
  title?: string;
  body?: string;
}

export interface DefaultPolicy {
  category: PolicyCategory;
  title: string;
  body: string;
}

export const POLICY_CATEGORY_LABELS: Record<PolicyCategory, string> = {
  cancellation: "Cancellation",
  late: "Late",
  no_show: "No-Show",
  rescheduling: "Rescheduling",
  other: "Other",
};

export const POLICY_CATEGORY_OPTIONS: {
  value: PolicyCategory;
  label: string;
}[] = (Object.keys(POLICY_CATEGORY_LABELS) as PolicyCategory[]).map(
  (value) => ({ value, label: POLICY_CATEGORY_LABELS[value] }),
);

export const MAX_POLICY_TITLE_LENGTH = 100;
